import React, { forwardRef } from 'react';
import '../About.css';

const About = forwardRef((props, ref) => {
  return (
    <section ref={ref} id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I'm a passionate full-stack developer with experience in building modern web applications. 
              I love creating scalable applications and solving complex problems through clean, efficient code.
            </p>
            <p>
              With a strong foundation in both frontend and backend development, I enjoy working on 
              projects that challenge me to learn and grow as a developer. I've contributed to 
              team projects and built full-stack applications from scratch.
            </p>
            <div className="about-info">
              <div className="info-item">
                <strong>Experience:</strong> Frontend Developer & Full Stack
              </div>
              <div className="info-item">
                <strong>Location:</strong> Nigeria
              </div>
              <div className="info-item">
                <strong>Availability:</strong> Open to opportunities
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default About;
